/*
 * Copyright (C) 2014 Spanning Cloud Apps LLC.  All rights reserved.
 */
'use strict';

/**
 * Filter module for ordinal.
 */
angular
  .module('filters.ordinal', [])
  /**
   * Filter used for adding ordinal to number.
   *
   * @param {int} num - The number to add ordinal.
   *
   * @returns {string} - The number as string with ordinal.
   */
  .filter('ordinal', function () {
    return function (num) {
      if (isNaN(num)) {
        return num;
      }

      var mod10 = num % 10,
        mod100 = num % 100;

      if (mod10 === 1 && mod100 !== 11) {
        return num + 'st';
      } else if (mod10 === 2 && mod100 !== 12) {
        return num + 'nd';
      } else if (mod10 === 3 && mod100 !== 13) {
        return num + 'rd';
      } else {
        return num + 'th';
      }
    };
  });
